import { useI18n } from 'builder/hooks/useI18n'
import { Button, Container, EmailNotificationText, EnabledText, TextContainer } from './styles'
const TRANSLATION = 'builder.job_search.alert_modal.manage_your_job_alerts.email_notifications'

interface Props {
  enabled: boolean
  onClick: () => void
}

export const EmailNotification = ({ enabled, onClick }: Props) => {
  const { i18n } = useI18n()
  return (
    <Container>
      <TextContainer>
        <EmailNotificationText>
          {i18n.t(`${TRANSLATION}.email_notifications`)}
        </EmailNotificationText>
        <EnabledText>{i18n.t(`${TRANSLATION}.${enabled ? `enabled` : `disabled`}`)}</EnabledText>
      </TextContainer>
      <Button onClick={onClick}>{`${i18n.t(`${TRANSLATION}.turn_all`)} ${i18n.t(
        enabled ? `${TRANSLATION}.off_word` : `${TRANSLATION}.on_word`,
      )}`}</Button>
    </Container>
  )
}
